enum AbnormalOrderRecordType {
    /** 打印后改地址 */
    CONSIGNEE_CHANGED = "CONSIGNEE_CHANGED",
    /** 打印后待发货订单被取消 */
    ORDER_CANCELED = "ORDER_CANCELED",
    /** 发货后订单被取消 */
    ORDER_CANCELED_AFTER_SHIPPED = "ORDER_CANCELED_AFTER_SHIPPED",
    /** 打印后商品项被取消 */
    ORDER_ITEM_CANCELED = "ORDER_ITEM_CANCELED",
    /** 发货后商品项被取消 */
    ORDER_ITEM_CANCELED_AFTER_SHIPPED = "ORDER_ITEM_CANCELED_AFTER_SHIPPED",
    /** 打印后商品部分数量被取消 */
    ORDER_ITEM_PART_QUANTITY_CANCELED = "ORDER_ITEM_PART_QUANTITY_CANCELED",
    /** 打印后退款 */
    REFUNDING_APPLIED = "REFUNDING_APPLIED",
    /** 打印后改备注 */
    SELLER_REMARKS_MODIFIED = "SELLER_REMARKS_MODIFIED",
    /** 打印后改属性 */
    SKU_PROPERTIES_MODIFIED = "SKU_PROPERTIES_MODIFIED",
}

export default AbnormalOrderRecordType;
